var isPrototypeOf = require('../internals/object-is-prototype-of');

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/an-instance.js
// module id = 107
// module chunks = 0 1